import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import LoginService from 'services/login';

import * as maintenanceIcon from '../../images/maintenance.png';

import './styles.scss'
import { Spinner } from 'react-bootstrap';

const Maintenance = () => {
  const [isLoading, setIsLoading] = useState(false)

  const logout = async () => {
    setIsLoading(true)
    try {
      await LoginService.logout();
    } catch (error) {
    } finally {
      localStorage.clear();
      window.location.reload();
    }
  };

  return (
    <div className="maintenance-container">
      <div className="card-message">
        <div className="img-div">
          <img src={maintenanceIcon} />
        </div>
        <h3>Portal em momento de atualização/manutenção.</h3>
        <p>Em breve, ele já estará disponível para acesso.</p>
        <p>Agradecemos a sua compreensão!</p>
      </div>
      <div className='card-btn-logout'>
        <button disabled={isLoading} className='btn btn-link d-flex align-items-center justify-content-between' onClick={() => logout()}>
          {isLoading ? <Spinner animation="border" color='#2F2B6C' size="sm" /> : <FontAwesomeIcon icon={faPowerOff} color='#2F2B6C' size='small' />}
          <span className='ml-1'>Sair</span>
        </button>
      </div>
    </div>
  )
}

export default Maintenance